import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import ToggleSwitch from '../shared/ToggleSwitch';
import TimePicker from "react-time-picker";
import CustomTimePicker from './CustomTimePicker';
import SelectInput from '../InputComponent/SelectInput';
import TextAreaInput from '../InputComponent/TextAreaInput';

const ManualEntryModal = ({ isOpen, onClose, onSave, members, isLoading }) => {
    const getCurrentTimeString = () => {
        const now = new Date();
        let hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12 || 12; // convert 0 -> 12, 13 -> 1
        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutes).padStart(2, "0");

        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    };
    const initialFormState = {
        memberId: '',
        timeIn: getCurrentTimeString(),
        timeOut: '',
        notes: '',
        override: false,
    };

    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        if (isOpen) {
            setFormData({
                ...initialFormState,
                memberId: members.length > 0 ? members[0].id : '',
            });
        }
    }, [isOpen, members]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleToggle = (checked) => {
        setFormData(prev => ({ ...prev, override: checked }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.memberId) {
            toast.error('Please select a member.');
            return;
        }
        const member = members.find(m => m.id === formData.memberId);
        onSave({ ...formData, memberName: member?.name ?? '' });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Manual Member Entry">
            <form onSubmit={handleSubmit} className="space-y-4">
                <SelectInput label={"Member"} name="memberId" value={formData.memberId} onChange={handleChange} isRequired={true}>
                    <option>Select Member</option>
                    {members.map(m => <option key={m.member_id} value={m.member_id}>{m.name} - {m.member_id}</option>)}
                </SelectInput> 
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <CustomTimePicker
                            label="Time In"
                            value={formData.timeIn}
                            onChange={(newTime) => setFormData((prev) => ({ ...prev, timeIn: newTime }))}
                        />
                    </div> 
                </div>
                <TextAreaInput label={"Notes"} name="notes" value={formData.notes} onChange={handleChange} rows="3" /> 
                {/* <div className="flex items-center justify-between pt-2">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Override Access</label>
                        <p className="text-xs text-gray-500">Allow entry even if plan is expired/blocked.</p>
                    </div>
                    <ToggleSwitch enabled={formData.override} setEnabled={handleToggle} />
                </div> */}
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button type="submit" disabled={isLoading} className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">{isLoading ? 'Loading...' : 'Save Entry'}</button>
                </div>
            </form>
        </Modal>
    );
};

export default ManualEntryModal;
